import * as XLSX from 'xlsx';

// Sample Tunisian first names
const firstNames = [
  'Mohamed', 'Ahmed', 'Youssef', 'Ali', 'Rania', 
  'Sami', 'Leila', 'Nour', 'Amal', 'Karim',
  'Hedi', 'Fatma', 'Amine', 'Hakim', 'Asma',
  'Slim', 'Meriem', 'Sofien', 'Ines', 'Zied'
];

// Sample Tunisian last names
const lastNames = [
  'Ben Ali', 'Trabelsi', 'Chahed', 'Jebali', 'Ben Salah',
  'Riahi', 'Mejri', 'Ben Youssef', 'Tlili', 'Laabidi',
  'Gharbi', 'Maaloul', 'Khazri', 'Hajri', 'Chebbi',
  'Rezgui', 'Slimani', 'Bouzaiene', 'Bouazizi', 'Triki'
];

// Generate a Tunisian phone number
const generatePhoneNumber = () => {
  // Tunisian mobile numbers start with 2, 4, 5, or 9
  const prefixes = ['2', '4', '5', '9'];
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
  
  // Generate 7 random digits for the rest of the number
  let number = prefix;
  for (let i = 0; i < 7; i++) {
    number += Math.floor(Math.random() * 10);
  }
  
  // Format as +216 XX XXX XXX
  return `+216 ${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`;
};

// Generate sample data
const generateSampleData = (count = 20) => {
  const data = [];
  
  // Add header row
  data.push(['Prénom', 'Nom', 'Téléphone']);
  
  // Add data rows
  for (let i = 0; i < count; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const phone = generatePhoneNumber();
    
    data.push([firstName, lastName, phone]);
  }
  
  return data;
};

// Create and download Excel file
export const downloadSampleExcel = () => {
  const data = generateSampleData();
  
  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);
  
  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Contacts');
  
  // Generate Excel file
  XLSX.writeFile(wb, 'sample_contacts_tunisie.xlsx');
};